import React from 'react';
import { GALLERY_CONSTS, optionsMap } from 'pro-gallery-lib';
const withSecondaryMedia = (WrappedComponent) => {
    return (props) => {
        const { itemWasHovered, isCurrentHover, hasSecondaryMedia, secondaryMediaItem } = props;
        if (props.options[optionsMap.behaviourParams.item.secondaryMedia.trigger] ===
            GALLERY_CONSTS[optionsMap.behaviourParams.item.secondaryMedia.trigger].OFF ||
            !hasSecondaryMedia) {
            return React.createElement(WrappedComponent, Object.assign({}, props));
        }
        const getClasses = () => {
            return ['secondary-media-item', isCurrentHover ? 'show' : 'hide'].join(' ');
        };
        const getSecondaryMediaItemProps = () => {
            const { createUrl, createMagnifiedUrl, style, html } = secondaryMediaItem;
            return Object.assign(Object.assign({}, props), { style,
                html,
                createUrl,
                createMagnifiedUrl });
        };
        return (React.createElement("div", { className: "item-with-secondary-media-container" },
            React.createElement(WrappedComponent, Object.assign({}, props)),
            React.createElement("div", { className: getClasses() }, itemWasHovered && React.createElement(WrappedComponent, Object.assign({}, getSecondaryMediaItemProps())))));
    };
};
export default withSecondaryMedia;
//# sourceMappingURL=withSecondMedia.js.map